import { constants } from 'config/constants';
import { INTEGRATIONS_TYPES } from 'config/integrationTypes';

// ── Device-family predicates ─────────────────────────────────────────────────
// The single place a category ID is turned into a family. Pure domain rules with
// no UI in them — the action menu that used to host these lives in the
// DeviceActions molecule now.

export const isGatewayDevice = (d) => constants.GATEWAY_CATEGORIES.includes(d?.defaultCategoryID);

/** Control-managed hardware (12/14/17/19) — a CAPABILITY, not a family: lockers included. */
export const isControlDevice = (d) => constants.CONTROL_DEVICE_CATEGORIES.includes(d?.defaultCategoryID);

/** Bookable lockers (14/19) — the Lockers product's devices. */
export const isLockerDevice = (d) => constants.BOOKEABLE_LOCKERS.includes(d?.defaultCategoryID);

/** Access smart locks (12/17). Lockers share the Control categories but are their own family. */
export const isSmartLock = (d) => isControlDevice(d) && !isLockerDevice(d);

export const isACSDevice = (d) => constants.ACS_DEVICE_CATEGORIES.includes(d?.defaultCategoryID);
export const isCamera = (d) => constants.CAMERA_CATEGORIES.includes(d?.defaultCategoryID);

export const isAssetDevice = (d) => !isControlDevice(d) && !isGatewayDevice(d) && !isACSDevice(d) && !isCamera(d);

/** Locks an Open Access schedule can drive (Control or TTLock): category first, integration as fallback. */
export const isOpenAccessLock = (d) => {
	if (d?.deviceID == null || isLockerDevice(d)) return false;
	return isControlDevice(d) || d.integrationID === INTEGRATIONS_TYPES.INTEGRATION_TTLOCK.id;
};
